import { resolveEnclosingTag } from './resolve-enclosing-tag';
import { resolveTextShowMoreAfter } from './text-attributes';
import type { NoContainerResolverContext } from '@source-components-react/types';

/**
 * True when RText is about to render an element that can carry a className —
 * any enclosing tag, block or inline, or a bare text with a show-more limit
 * (which renders as a `span`). True bare text has no element, so false.
 *
 * Shares `resolveEnclosingTag` and `resolveTextShowMoreAfter` with RText and
 * `resolveNoContainer`: if this disagreed with what the component renders, a
 * class would either land on nothing or force a redundant wrapper. The limit
 * is part of the answer because a configured budget always produces a root
 * element, even when the filled text happens to fit.
 */
export const resolveRendersOwnElement = ({
  componentAttributes,
}: NoContainerResolverContext): boolean =>
  !!resolveEnclosingTag(componentAttributes) ||
  resolveTextShowMoreAfter(componentAttributes) !== undefined;
